import { createRouter, createWebHistory } from 'vue-router'
import { ref, nextTick } from 'vue'
export const navigating = ref(false)
const positions = new Map()
let navigationId = 0
const HomePage = () => import('../views/Home.vue')
const PricePage = () => import('../views/Price.vue')
const About = () => import('../views/About.vue')
const Free = () => import('../views/Free.vue')
const Tutorial = () => import('../views/Tutorial/index.vue')
const Display = () => import('../views/Display.vue')
const DesignerDetail = () => import('../views/DesignerDetail.vue')
const Tools = () => import('../views/Tools.vue')

const routes = [
  { path: '/announcements', component: () => import('../views/Announcements.vue') },
  { path: '/announcements/:id', component: () => import('../views/AnnouncementDetail.vue') },
  { path: '/television', name: 'Television', component: () => import('../views/Television.vue') },
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/price',
    name: 'Price',
    component: PricePage
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/free',
    name: 'Free',
    component: Free
  },
  {
    path: '/tutorial',
    component: Tutorial,
    children: [
      ...['items', 'recipes', 'help'].map(mode => ({
        path: mode,
        component: () => import('../views/Tutorial/GuideLibrary.vue'),
        props: { mode }
      })),
      {
        path: '',
        component: () => import('../views/Tutorial/TutorialContent.vue'),
        props: { contentId: 'welcome' }
      },
      {
        path: 'skills',
        component: () => import('../views/Tutorial/content/basics/Skills.vue')
      },
      {
        path: 'space',
        component: () => import('../views/Tutorial/content/basics/Space.vue')
      },
      {
        path: 'level-up',
        component: () => import('../views/Tutorial/content/basics/LevelUp.vue')
      },
      {
        path: 'nobility',
        component: () => import('../views/Tutorial/content/basics/Nobility.vue')
      },
      {
        path: 'backpack',
        component: () => import('../views/Tutorial/content/basics/Backpack.vue')
      },
      {
        path: 'faq',
        component: () => import('../views/Tutorial/content/basics/FAQ.vue')
      },
      {
        path: 'ant-instance',
        component: () => import('../views/Tutorial/content/activities/AntInstance.vue')
      },
      {
        path: 'restaurant',
        component: () => import('../views/Tutorial/content/activities/Restaurant.vue')
      },
      {
        path: 'spring-festival',
        component: () => import('../views/Tutorial/content/activities/SpringFestival.vue')
      },
      {
        path: 'winter-resources',
        component: () => import('../views/Tutorial/content/activities/WinterResources.vue')
      },
      {
        path: 'lantern-festival',
        component: () => import('../views/Tutorial/content/activities/LanternFestival.vue')
      },
      {
        path: 'new-term',
        component: () => import('../views/Tutorial/content/activities/NewTerm.vue')
      },
      {
        path: 'valentines-day',
        component: () => import('../views/Tutorial/content/activities/ValentinesDay.vue')
      },
      {
        path: 'fantasy-forest',
        component: () => import('../views/Tutorial/content/activities/FantasyForest.vue')
      },
      {
        path: 'coffee-basic',
        component: () => import('../views/Tutorial/content/coffee/basic.vue')
      }
    ]
  },
  {
    path: '/display',
    name: 'Display',
    component: Display
  },
  {
    path: '/designer/:id',
    name: 'DesignerDetail',
    component: DesignerDetail
  },
  {
    path: '/tools',
    name: 'Tools',
    component: Tools
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  async scrollBehavior(to, from, savedPosition) {
    const id = navigationId;
    await nextTick();
    await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    if (id !== navigationId) return false;
    return savedPosition || (to.path === '/display' && from.name === 'DesignerDetail' ? positions.get('/display') : null) || { left: 0, top: 0 };
  }
})

router.beforeEach(fromTo => {
  navigationId++;
  positions.set(router.currentRoute.value.path, { left: window.scrollX, top: window.scrollY });
  if (positions.size > 30) positions.delete(positions.keys().next().value);
  navigating.value = fromTo.fullPath !== router.currentRoute.value.fullPath;
});
router.afterEach(() => { navigating.value = false; });
router.onError(() => { navigating.value = false; });
export default router
